export const COLLABORATOR_GRID = '2fr 3fr 1fr 6fr'
export const BUSINESS_GRID = '1fr 1fr 1fr 1fr 1fr'
export const CONTRIBUTOR_GRID = '2fr 2fr 1fr'
export const RESOURCE_GRID = '1fr 3fr 1fr'
